<script setup lang="ts">
import { useThemeStore } from "@/stores/theme";
import { AppProvider } from "@soft-db/ui";
import { storeToRefs } from "pinia";
import DevOptionsDialog from "./components/DevOptionsDialog";
import LogoSVG from "./components/LogoSVG.vue";
import { provideSentryUser } from "./plugins";
import { useAuthStore } from "./stores";
import { useAppStore } from "./stores/app";
import { provideLocale } from "./use/locale-switcher";
import { provideSyncDate } from "./use/sync-date";

provideSyncDate().sync();

provideLocale();
provideSentryUser();

const authStore = useAuthStore();
const appStore = useAppStore();

onMounted(async () => {
	await authStore.init();
	if (location.pathname.startsWith("/auth") || location.pathname.startsWith("/eula")) {
		return;
	}

	await appStore.init();
});

const { isDark } = storeToRefs(useThemeStore());
</script>

<template>
	<AppProvider :dark="isDark">
		<RouterView v-if="!appStore.isLoading" />

		<SoftFadeTransition mode="out-in">
			<div
				v-if="appStore.isLoading"
				class="bg-base-300 fixed inset-0 z-50 flex h-full items-center justify-center"
			>
				<div class="relative">
					<SoftRadialProgress class="h-32 w-32" color="primary" />
					<div class="absolute left-1/4 top-1/4 h-16 w-16">
						<LogoSVG class="pulse" />
					</div>
				</div>
			</div>
		</SoftFadeTransition>

		<DevOptionsDialog />
	</AppProvider>
</template>
